<template lang="pug">
    el-dialog(:title="title",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm",:inline="true",label-suffix=":" label-width="90px")
            el-card(shadow="never")
                el-form-item(label="俱乐部名" prop="name")
                    div.width_label {{ruleForm.name}}
                el-form-item(label="会长姓名" prop="matchName")
                    div.width_label {{ruleForm.matchName}}
                el-form-item(label="会长账号" prop="matchCount")
                    div.width_label {{ruleForm.matchCount}}
                el-form-item(label="俱乐部等级" prop="level")
                    div.width_label {{ruleForm.level}}
                el-form-item(label="俱乐部积分" prop="yearScore")
                    div.width_label {{ruleForm.yearScore}}
                br
                el-form-item(label="注册时间" prop="regestTime")
                    div.width_label {{ruleForm.regestTime}}
                el-form-item(label="全员女子" prop="allWomen")
                    div.width_label(v-if="ruleForm.allWomen == 1") 是
                    div.width_label(v-if="ruleForm.allWomen == 2") 否

            el-row(style="padding-top:10px")
                el-col(:span="24")
                    el-button(type="primary" @click="addEnrollView") 会员转入
                    el-button(type="primary" @click="exportExcel") 导出
                    el-button(@click="deleteItem()"  type='danger') 删除
            el-row(style="padding-top:10px")
                el-col(:span="24")

                        el-table(:data="enrollDataOne" border @selection-change="enrollOneChange")
                                el-table-column(type="selection" align='center')
                                el-table-column(prop="name" label="会员姓名" align='center')
                                el-table-column(prop="mobile" label="会员账号" align='center' width="180")
                                el-table-column(prop="gender" label="性别" align='center')
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="age" label="年龄" align='center')
                                el-table-column(prop="level" label="级别" align='center')
                                el-table-column(prop="job" label="职务" align='center' )
                                    template(slot-scope="scope")
                                        el-tag(:type="scope.row.job === 1 ? 'primary' : 'info'" effect="dark" disable-transitions)
                                            font(v-if="scope.row.job == 1") 会长
                                            font(v-if="scope.row.job == 2") 会员
                                el-table-column(prop="transferTimes" label=" 转会次数" align='center' )
                                el-table-column(prop="type" label="会员来源" align='center' width="130")
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.type == 1") 注册会员
                                        font(v-if="scope.row.type == 2") 初始会员
                                        font(v-if="scope.row.type == 3") 荣誉会员
                                el-table-column(prop="joinTime" label="入会时间" align='center' sortable)
                                el-table-column(header-align='center',align='center',label='操作' width='100')
                                    template(slot-scope="scope")
                                        el-menu.menuPonit(@open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                                            el-submenu(index="1")
                                                template(slot="title")
                                                    i(class="el-icon-more" style='color:#02B90D;')
                                                el-menu-item-group()
                                                    el-menu-item(index="1-1" :disabled="scope.row.job==1" @click="updateBench(scope.row)") 设为会长
                                                    el-menu-item(index="1-2"  @click="deleteItem(scope.row.id)") 删除
            el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            //- 会员转入弹窗
            el-dialog(title="添加人员"  :visible.sync="addVisible" width="80%" :append-to-body='true' :modal-append-to-body='false' @close="updateReferee_cancelClose")
                el-row
                    el-col(:span="11")
                        el-card(shadow="never")
                            div(slot="header" style="display: flex;")
                                el-input(v-model="memberName" clearable style="flex: 1;" placeholder="请输入姓名/手机号码/级别")
                                el-button(icon="el-icon-search" style="margin-left: 10px;" @click="sizeChangeHandle_mb(pageSize_mb)") 查询
                        div
                            el-table(:data="leftData" border  @selection-change="checkAll" max-height="300")
                                el-table-column(type="selection" align='center')
                                el-table-column(prop="name" label="姓名" align='center')
                                el-table-column(prop="gender" label="性别" align='center'  )
                                    template(slot-scope="scope")
                                        font(v-if="scope.row.gender === 0") 男
                                        font(v-if="scope.row.gender === 1") 女
                                el-table-column(prop="level" label="级别" align='center')
                                el-table-column(prop="mobile" label="手机号码" align='center' )
                            el-pagination(@size-change='sizeChangeHandle_mb', @current-change='currentChangeHandle_mb', :current-page='pageIndex_mb', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize_mb', :total='totalPage_mb', layout='total, sizes, prev, pager, next, jumper')
                    el-col(:span="2")
                        div.opSetting
                            div(@click="handelSelect")
                                el-button(icon="el-icon-d-arrow-right" :disabled="nowSelectData.length ? false:true" :size="buttonSize" type="primary") 选中
                            div.spacing(@click="handleRemoveSelect")
                                el-button(icon="el-icon-d-arrow-left" :disabled="nowSelectRightData.length ? false:true" :size="buttonSize" type="danger") 取消
                    el-col(:span="11")
                        el-card(shadow="never")
                            div(slot="header")
                                font.font_label 已选择的会员
                            div
                                el-table(:data="rightData" border @selection-change="checkRightAll" max-height="300")
                                    el-table-column(type="selection" align='center')
                                    el-table-column(prop="name" label="姓名" align='center')
                                    el-table-column(prop="gender" label="性别" align='center' )
                                        template(slot-scope="scope")
                                            font(v-if="scope.row.gender === 0") 男
                                            font(v-if="scope.row.gender === 1") 女
                                    el-table-column(prop="level" label="级别" align='center' )
                                    el-table-column(prop="mobile" label="手机号码" align='center' )
                span.dialog-footer(slot="footer")
                    el-button(@click="addEnroll" type="primary") 确 定
                    el-button(@click="addVisible=false") 取 消
        span.dialog-footer(slot="footer")
            el-button(@click="visible=false") 返回
</template>
<script>
    import table from './table.js'
    export default {
        data () {
            return {
                isCollapse: true,
                table: {
                    columns: table.columns,
                    data: null,
                    size: 'mini',
                    stripe: true,
                    border: true
                },
                argueVisible: false,
                addOrViewArgue: true,
                argueTitle: '',
                argueForm: {
                    argue: ''
                },
                refundList: [],
                regMember: '', //注册会员
                initMember: '', //初始化会员
                honour: '', //荣誉会员
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                pageIndex_mb: 1,
                pageSize_mb: 10,
                totalPage_mb: 0,
                memberName: '',
                nowCbId: '',

                buttonSize: 'large',
                options: [],
                value: '',
                leftData: [],
                rightData: [], // 右边列表
                nowSelectData: [], // 左边选中列表数据
                nowSelectRightData: [], // 右边选中列表数据
                visible: false,
                addVisible: false,
                refundVisible: false,
                title: '成员管理',
                enrollData: [],
                enrollDataOne: [],
                enrollDataTwo: [],
                enrollDataChange: [],
                enrollDataOneChange: [],
                enrollDataTwoChange: [],
                ruleForm: {
                    id: '',
                    name: '',
                    matchName: '',
                    matchCount: '',
                    level: '',
                    scors: '',
                    regestTime: '',
                    allWomen: ''
                },
                enrollList: {
                    ctId: '',
                    bench: '0', //是否替补队员 0:否 1:是
                    matchType: 1, //业务类型（1分级赛、2俱乐部）,
                    mbMemberList: []
                },
                payRefund: null,
                refundForm: {
                    refundScale: undefined,
                    refundFee: undefined
                },
                radio: undefined,
                loading: null,
                refundFeeMax: 0
            }
        },
        methods: {
             //操作三点
            handleOpen (key, keyPath) {

            },
            handleClose (key, keyPath) {

            },
            init (id, row) {
                // 头部信息回显
                this.ruleForm.name = row.name
                this.ruleForm.matchName = row.chairman
                this.ruleForm.matchCount = row.chairmanId
                this.ruleForm.level = { 1: '甲A', 2: '甲B', 3: '乙A', 4: '乙B', 5: '丙A', 6: '丙B', 7: '丁A', 8: '丁B', 9: '资格' }[row.level]
                this.ruleForm.yearScore = row.yearScore
                this.ruleForm.regestTime = row.enrollTime
                this.ruleForm.allWomen = row.allWomen
                // 数据初始化
                this.pageIndex = 1
                this.pageSize = 10
                this.ruleForm.id = id
                this.radio = undefined
                this.visible = true
                this.regMember = ''
                this.initMember = ''
                this.honour = ''
                this.enrollData = []
                this.enrollDataOne = []
                this.enrollDataTwo = []
                this.enrollDataChange = []
                this.enrollDataOneChange = []
                this.enrollDataTwoChange = []

                //会员列表
                this.getenrollDataOne()
            },
            getenrollDataOne () {
                this.$http({
                    url: this.$http.adornUrl(`/mbMember/getMemberListCb`),
                    method: 'post',
                    data: {
                        cbId: this.ruleForm.id,
                        page: this.pageIndex,
                        limit: this.pageSize
                    }
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.enrollDataOne = data.page.records
                        this.totalPage = data.page.total
                    }
                }).then(() => {
                    // this.getEnrollData(id)
                })
            },
            sizeChangeHandle (val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getenrollDataOne()
            },
            currentChangeHandle (val) {
                this.pageIndex = val
                this.getenrollDataOne()
            },
            //设置为会长
            updateBench (row) {
                let title = '是否设置为会长？'
                this.$confirm(title, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.$http({
                        url: this.$http.adornUrl(`/mbMember/setPresident?id=${row.id}&cbId=${this.ruleForm.id}`),
                        method: 'post'
                    }).then((data) => {
                        if (data && data.code !== 0) return this.$message.success('操作失败!')
                        this.$message.success('操作成功!')
                        this.getenrollDataOne()
                        this.$emit('setLeader')
                        this.ruleForm.matchName = row.name
                        this.ruleForm.matchCount = row.mobile
                    })
                }).catch(() => {
                    this.$message.info('已取消')
                })
            },
            //添加人员页面
            addEnrollView () {
                this.addVisible = true
                this.memberName = ''
                this.rightData = []
                this.enrollList = {}
                this.nowSelectRightData = [] // 右边选中列表数据
                this.enrollList.ctId = this.ruleForm.id
                this.getLeftData()
            },
             //主力勾选事件
            enrollOneChange (val) {
                this.enrollDataOneChange = val
            },
            deleteItem (val) {
            let arr = []
            let ids = ''
            if (!val) { //批量删除按钮
                if (this.enrollDataOneChange.length < 1) {
                return this.$message.error('请选择至少一条数据进行删除操作！')
                }

                this.enrollDataOneChange.forEach(e => {
                arr.push(e.id)
                })
                ids = arr.join()
                this.enrollDataOneChange = []
            } else {
                ids = val
            }
            console.log(ids)

            this.$confirm('是否删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                this.$showLoading()
                this.$http({
                    url: this.$http.adornUrl(`/mbMember/deleteCbMember?ids=${ids}&cbId=${this.ruleForm.id}`),
                    method: 'post'
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.$message.success('删除成功！')
                        this.getenrollDataOne()
                        this.$showLoading('close')
                    }
                })
            }).catch(() => {
                this.$message.info('已取消')
            })
            },
            //刷新添加人员左边table
            getLeftData () {
                this.$http({
                    url: this.$http.adornUrl(`/mbMember/getMemberListNoCb`),
                    method: 'post',
                    data: {
                        page: this.pageIndex_mb,
                        limit: this.pageSize_mb,
                        name: this.memberName,
                        cbId: this.ruleForm.id,
                        job: 2//选择会员
                        // 'status':1,//只查询已实名认证的会员
                        // 'ids':arrId.join()
                    }
                }).then(data => {
                    if (data && data.code === 0) {
                        this.leftData = data.page.records
                        this.totalPage_mb = data.page.total
                    } else {
                        this.leftData = []
                        this.totalPage_mb = 0
                    }
                })
            },
            // 每页数
            sizeChangeHandle_mb (val) {
                this.pageSize_mb = val
                this.pageIndex_mb = 1
                this.getLeftData()
            },
            // 当前页
            currentChangeHandle_mb (val) {
                this.pageIndex_mb = val
                this.getLeftData()
            },
             // 选中
            handelSelect () {
                this.rightData = this.handleConcatArr(this.rightData, this.nowSelectData)
                this.handleRemoveTabList(this.nowSelectData, this.leftData)
                this.nowSelectData = []
            },
            // 取消
            handleRemoveSelect () {
                this.leftData = this.handleConcatArr(this.leftData, this.nowSelectRightData)
                this.handleRemoveTabList(this.nowSelectRightData, this.rightData)
                this.nowSelectRightData = []
            },
            handleConcatArr (rightData, nowSelectData) {
                let arr = []
                arr = arr.concat(rightData, nowSelectData)
                return arr
            },
            handleRemoveTabList (isNeedArr, originalArr) {
                if (isNeedArr.length && originalArr.length) {
                    for (let i = 0; i < isNeedArr.length; i++) {
                        for (let k = 0; k < originalArr.length; k++) {
                            if (isNeedArr[i]['name'] === originalArr[k]['name']) {
                                originalArr.splice(k, 1)
                            }
                        }
                    }
                }
            },
            openFullScreen () {
              this.loading = this.$loading({
                  lock: true,
                  text: '加载中',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
              })
            },
            //添加人员入库
            addEnroll () {
                if (this.rightData.length === 0) {
                    this.$message.error('没有要添加的会员!')
                } else if (this.rightData.length > 0) {
                    this.$showLoading()
                    let ids = []
                    console.log(this.rightData)
                    this.rightData.forEach(data => {
                        ids.push(data.id)
                    })
                    this.$http({
                        url: this.$http.adornUrl(`/mbMember/addList?cbId=${this.ruleForm.id}`),
                        method: 'post',
                        data: {
                            list: ids
                        }
                    }).then(res => {
                        if (res && res.code !== 0) return this.$message.error('操作失败！')
                        this.$message.success('操作成功！')
                        this.addVisible = false
                        this.getenrollDataOne()
                        this.$showLoading('close')
                    }).catch(() => {
                        this.$showLoading('close')
                    })
                }
            },

            checkAll (val) {
                this.nowSelectData = val
            },
            checkRightAll (val) {
                this.nowSelectRightData = val
            },

            //导出excel
            exportExcel () {
                this.$http({
                    url: this.$http.adornUrl('/mbMember/excelDown'),
                    method: 'post',
                    data: {
                        cbId: this.ruleForm.id
                    }
                }).then(data => {
                    console.log('会员列表信息：', data)
                    if (data) {
                        if (data.length === 0) {
                            this.$message.info('没有要导出的数据!')
                            return
                        }
                        let exportData = data
                        for (let i of exportData) {
                            i.type = { 1: '注册会员', 2: '初始会员', 3: '荣誉会员' }[i.type]
                            i.gender = { 0: '男', 1: '女' }[i.gender]
                            i.byx1 = { 0: '正常', 1: '禁赛', 2: '禁训', 3: '禁赛/禁训' }[i.byx1]
                            i.job = { 1: '会长', 2: '会员' }[i.job]
                        }
                        console.log('导出的数据：', exportData)
                        this.$export.excel({
                            columns: [
                                { label: '会员姓名', prop: 'name' },
                                { label: '会员账号', prop: 'mobile' },
                                { label: '性别', prop: 'gender' },
                                { label: '级别', prop: 'level' },
                                { label: '职务', prop: 'job' },
                                { label: '会员来源', prop: 'type' },
                                { label: '入会时间', prop: 'joinTime' }
                            ],
                            data: exportData,
                            title: this.ruleForm.name + '俱乐部成员信息'
                        }).then(() => {
                            this.$message.success('导出表格成功')
                        })
                    }
                })
            },
            updateReferee_cancelClose () {
                this.memberName = ''
                this.pageIndex_mb = 1
                this.pageSize_mb = 10
            }
        }
    }
</script>
<style>
    .width_label{
        width:180px;
    }
    .opSetting{
        text-align: center;
        margin-top:30px;
    }
    .spacing{
        margin-top:10px;
    }
    .font_label{
        font-weight:bold;
        font-size:18px;
    }
    .leader{
        border: 1px solid #ccc;
        background: #eee
    }
</style>
